import {
  combineActions,
  handleActions
}                                    from 'redux-actions';
import { List }                      from 'immutable';
import {
  ACTIONS,
  METHOD_GET,
  METHOD_PUT
}                                    from '../../../actions/utils/apiResources/apiResourceActions.const';
import { buildMethodsByActionGroup } from '../../../actions/utils/apiResources/buildSyncActions';
import { prepareRequestKey }         from './prepareRequestKey';

const buildInProgressReducer = (resource) => {

  // Actions that will add items to the 'inProgress' state.

  const addActions = combineActions(
    buildMethodsByActionGroup[ACTIONS.CREATE](resource).request,
    buildMethodsByActionGroup[ACTIONS.LIST](resource).request,
    buildMethodsByActionGroup[ACTIONS.SHOW](resource).request,
    buildMethodsByActionGroup[ACTIONS.UPDATE](resource, METHOD_GET).request,
    buildMethodsByActionGroup[ACTIONS.UPDATE](resource, METHOD_PUT).request,
    buildMethodsByActionGroup[ACTIONS.DEL](resource).request,
  );


  // Actions that will remove items from the 'inProgress' state.

  const removeActions = combineActions(
    buildMethodsByActionGroup[ACTIONS.CREATE](resource).success,
    buildMethodsByActionGroup[ACTIONS.LIST](resource).success,
    buildMethodsByActionGroup[ACTIONS.SHOW](resource).success,
    buildMethodsByActionGroup[ACTIONS.UPDATE](resource, METHOD_GET).success,
    buildMethodsByActionGroup[ACTIONS.UPDATE](resource, METHOD_PUT).success,
    buildMethodsByActionGroup[ACTIONS.DEL](resource).success,
    buildMethodsByActionGroup[ACTIONS.CREATE](resource).failure,
    buildMethodsByActionGroup[ACTIONS.LIST](resource).failure,
    buildMethodsByActionGroup[ACTIONS.SHOW](resource).failure,
    buildMethodsByActionGroup[ACTIONS.UPDATE](resource, METHOD_GET).failure,
    buildMethodsByActionGroup[ACTIONS.UPDATE](resource, METHOD_PUT).failure,
    buildMethodsByActionGroup[ACTIONS.DEL](resource).failure,
  );


  return handleActions(
    {

      [addActions](state, {payload}) {

        const key = prepareRequestKey(payload);

        if (state.has(key)) {

          return state;

        }

        return state.push(key);

      },

      [removeActions](state, {meta}) {

        const key = prepareRequestKey(meta);

        if (!state.contains(key)) {

          return state;

        }

        return state.filter(item => (key !== item));

      },

    },

    List()
  );

};


export default buildInProgressReducer;



// WEBPACK FOOTER //
// ./src/reducers/utils/apiResources/buildInProgressReducer.js